import Abstract from './abstract';

export default class ABTestingView extends Abstract {
  init() {
    this.getElement();

    this.setViewPattern();

    this.addEvent();
  }

  getElement() {
    this.rankingArticleModule = document.querySelector('.js-ranking-article-module');
  }

  setViewPattern() {
    if (!this.rankingArticleModule) {
      return;
    }

    const { classname } = window.currentRankingArticleModuleData || { classname: 'ranking-article-module-default' };
    this.rankingArticleModule.classList.add(classname);
  }

  addEvent() {
  }
}
